// extracted by mini-css-extract-plugin
export default {"treatmentPlanDetailsContainer":"ViewMedicationTemplateDetails_treatmentPlanDetailsContainer__C+VLR"};